import { render, staticRenderFns } from "./FinalRank.vue?vue&type=template&id=3bd2e072&scoped=true&"
import script from "./FinalRank.vue?vue&type=script&lang=js&"
export * from "./FinalRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2e072",
  null
  
)

export default component.exports